import React from "react";
import { Box, Flex, Text, Spacer, Badge } from "@chakra-ui/react";

// Left-hand country list (Default + countries), highlighting the selected one —
// the same look as Rule Management. `isCustom(code)` (optional) shows a "custom" badge.
function CountrySideList({ items, selected, onSelect, isCustom }) {
  return (
    <Box w="190px" mr={3} borderWidth="1px" borderRadius="md" p={1} maxH="320px" overflowY="auto">
      {items.map((c) => {
        const isSel = c.code === selected;
        return (
          <Flex
            key={c.code}
            p={2}
            mb={1}
            borderRadius="md"
            cursor="pointer"
            alignItems="center"
            backgroundColor={isSel ? "teal.500" : "transparent"}
            color={isSel ? "white" : "inherit"}
            _hover={{ backgroundColor: isSel ? "teal.500" : "gray.100" }}
            onClick={() => onSelect(c.code)}
          >
            <Text fontSize="13px">{c.name}</Text>
            <Spacer />
            {c.code !== "default" && isCustom && isCustom(c.code) && (
              <Badge colorScheme={isSel ? "whiteAlpha" : "purple"} fontSize="0.6em">
                custom
              </Badge>
            )}
          </Flex>
        );
      })}
    </Box>
  );
}

export default CountrySideList;
